import { render, staticRenderFns } from "./AgencyClients.vue?vue&type=template&id=6f8b8cd4&scoped=true&"
import script from "./AgencyClients.vue?vue&type=script&lang=ts&"
export * from "./AgencyClients.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyClients.vue?vue&type=style&index=0&id=6f8b8cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b8cd4",
  null
  
)

export default component.exports